import React, { FC } from 'react';

import iconClose from '@assets/close.svg';
import useDeviceType from '@hooks/useDeviceType';
import { TRACK_OFFICE_INFO_BUTTON_CLICK } from '@services/stats';

import st from './Header.module.css';

type HeaderProps = {
  onBack: () => void;
  title?: string;
};

const Header: FC<HeaderProps> = ({ title = 'Центр госуслуг', onBack }) => {
  const onClick = () => {
    onBack();
    TRACK_OFFICE_INFO_BUTTON_CLICK('goBack');
  };
  const { phone } = useDeviceType();

  return phone ? (
    <div className={st.container}>
      {title}
      <button
        type="button"
        className={st.btnClose}
        title="Закрыть"
        onClick={onClick}
      >
        <img src={iconClose} className={st.iconClose} alt="Закрыть" />
      </button>
    </div>
  ) : null;
};

export default Header;
